import { createContext, useContext } from "react";

import type * as Type from "./type";

type ViewModel = Type.FormModel["ViewModel"];

export type MarketingVoucherEditContextType = {
	viewModel: ViewModel;
	onSetViewModel: <K extends keyof ViewModel>(values: { key: K; value: ViewModel[K] }[]) => void;
};

export const MarketingVoucherEditContext = createContext<MarketingVoucherEditContextType | null>(null);

export const useMarketingVoucherEditContext = () => {
	const context = useContext(MarketingVoucherEditContext);

	if (!context) {
		throw new Error("useMarketingVoucherEditContext must be used within a MarketingVoucherEditContext.Provider");
	}

	return {
		viewModel: context.viewModel,
		onSetViewModel: context.onSetViewModel,
	};
};
